module.exports = __webpack_public_path__ + "files/fa078bc9851696dc6fcbe6d5a81cab23.png";